import { Routes } from '@angular/router';
import {AuthenticationGuard} from './core/gaurds/authentication.guard';
import {APPLICATION_ROUTES_CONSTANTS} from './core/constants/application-routes.constants';
import {LayoutComponent} from './features/layout/components/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: APPLICATION_ROUTES_CONSTANTS.ROUTES.REVIEW_SESSION.REVIEW_SESSION,
    pathMatch: 'full'
  },
  {
    path: APPLICATION_ROUTES_CONSTANTS.ROUTES.HOME,
    loadChildren: () => import('./features/home/home-module')
      .then(m => m.HomeModule)
  },
  {
    path: APPLICATION_ROUTES_CONSTANTS.BASES.AUTHENTICATION,
    loadChildren: () => import('./features/authentication/authentication-module')
      .then(m => m.AuthenticationModule)
  },


  {
    path: APPLICATION_ROUTES_CONSTANTS.ROUTES.PRIVACY,
    loadComponent: () => import('./features/privacy/privacy.component')
      .then(m => m.PrivacyComponent)
  },
  {
    path: APPLICATION_ROUTES_CONSTANTS.ROUTES.TERMS,
    loadComponent: () => import('./features/terms/terms.component')
      .then(m => m.TermsComponent)
  },
  {
    path: APPLICATION_ROUTES_CONSTANTS.ROUTES.ABOUT_US,
    loadComponent: () => import('./features/about-us/about-us.component')
      .then(m => m.AboutUsComponent)
  },

  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: APPLICATION_ROUTES_CONSTANTS.ROUTES.REVIEW_SESSION.REVIEW_SESSION, pathMatch: 'full' },
      // Dashboard is hidden/disabled for now - default landing route is the library instead
      // {
      //   path: APPLICATION_ROUTES_CONSTANTS.ROUTES.DASHBOARD,
      //   loadChildren: () => import('./features/dashboard/dashboard-module')
      //     .then(m => m.DashboardModule),
      //   canActivate: [AuthenticationGuard]
      // },
      {
        path: APPLICATION_ROUTES_CONSTANTS.ROUTES.REVIEW_SESSION.REVIEW_SESSION,
        loadChildren: () => import('./features/review-session/review-session-module')
          .then(m => m.ReviewSessionModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: APPLICATION_ROUTES_CONSTANTS.ROUTES.SOURCES,
        loadChildren: () => import('./features/source/source-module')
          .then(m => m.SourceModule),
        canActivate: [AuthenticationGuard]
      },
      // {
      //   path: APPLICATION_ROUTES_CONSTANTS.ROUTES.HIGHLIGHTS,
      //   loadChildren: () => import('./features/highlight/highlight-module')
      //     .then(m => m.HighlightModule),
      //   canActivate: [AuthenticationGuard]
      // },
      // {
      //   path: APPLICATION_ROUTES_CONSTANTS.ROUTES.REMINDER_LOGS,
      //   loadChildren: () => import('./features/reminder-log/reminder-log-module')
      //     .then(m => m.ReminderLogModule),
      //   canActivate: [AuthenticationGuard]
      // },
      {
        path: APPLICATION_ROUTES_CONSTANTS.ROUTES.USER_SETTINGS,
        loadChildren: () => import('./features/user-setting/user-setting-module')
          .then(m => m.UserSettingModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.IMPORT,
        loadChildren: () => import('./features/import/import-module')
          .then(m => m.ImportModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: APPLICATION_ROUTES_CONSTANTS.ROUTES.USER.USER,
        loadChildren: () => import('./features/user/user-module')
          .then(m => m.UserModule),
        canActivate: [AuthenticationGuard]
      }
    ],
  },

  { path: '**', redirectTo: '' },
];
